;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.pinterest = (function () {
    // source: http://dgrigg.com/blog/2012/04/04/dynamic-pinterest-button/

    const refreshPinterestButton = function (element) {
      // currently NOT being used
      const $el = $(element)
      const url = $el.attr('data-url')
      const media = $el.attr('data-media')
      const description = $el.attr('data-description')

      const href = 'http://pinterest.com/pin/create/button/?url=' + url + '&media=' + media + '&description=' + description
      const html = '<a href="' + href + '" class="pinterest" data-pin-log="button_pinit"><span class="icon-pinterest"></span></a>'

      $el.parent().html(html)
    }

    const reloadPinterestScript = function () {
      // remove and add pinterest js
      $('script[src*="assets.pinterest.com/js/pinit_main.js"], script[src*="assets.pinterest.com/js/pinit.js"]').remove()
      const js = $('<script data-pin-build="parsePinBtns" src="' + '//assets.pinterest.com/js/pinit.js' + '" type="text/javascript"></script>')
      $('body').append(js)
    }

    return {
      update: refreshPinterestButton,
      reload: reloadPinterestScript
    }
  }())

  $(function () {

  })
}(jQuery, window))
